// The Settle modal is shared by reservations, contracts, POS sales and work
// orders, so these events are surface-agnostic.

// CARD-PRESENT SETTLE
export const CARD_READER_SELECTED = "settle_payment:card_reader_selected"
export const CARD_READER_PROCESSED = "settle_payment:card_reader_processed"
